<template>
  <div id="samenwerking" class="mb-3 mr-4 d-flex align-items-center justify-content-between">
    <div
      class="logo-width d-flex align-items-center justify-content-center"
      v-for="logo in this.logos"
      :key="logo.naam"
    >
      <logo class="w-75" :src="logo.src" :alt="logo.naam" />
    </div>
  </div>
</template>

<script>
import logo from '@/components/Logo.vue';

export default {
  name: 'samenwerking',
  components: {
    logo,
  },
  data() {
    return {
      logos: [
        {
          naam: 'peer',
          src: '/images/wiezijnwij/peer.svg',
        },
        {
          naam: 'ejv',
          src: '/images/wiezijnwij/ejv.png',
        },
        {
          naam: 'pelt',
          src: '/images/wiezijnwij/pelt.svg',
        },
      ],
    };
  },
};
</script>
